import { Box } from '@factorialco/deprecated-design-system'
import { NotesTextEditor } from '@factorialco/f0-react/dist/experimental'

import { useNotesTextEditor } from 'modules/pages/lib/hooks/useNotesTextEditor'
import { editorAlignmentOffset } from 'modules/trainings/components/content/items/shared/styles.vanilla.css'

export type InlineEditableDescriptionProps = {
  value: string
  readOnly: boolean
  onChange: (value: string) => void
  editorKey: string
  placeholder: string
}

export const InlineEditableDescription = ({
  value,
  readOnly,
  onChange,
  editorKey,
  placeholder,
}: InlineEditableDescriptionProps) => {
  const { toolbarLabels } = useNotesTextEditor()

  const parseDescriptionContent = (description: string) => {
    if (!description) return ''
    try {
      return JSON.parse(description)
    } catch {
      return description
    }
  }

  return (
    <Box className={editorAlignmentOffset}>
      <NotesTextEditor
        key={editorKey}
        initialEditorState={{
          content: parseDescriptionContent(value),
        }}
        placeholder={placeholder}
        labels={{
          toolbarLabels,
        }}
        onChange={({ json }) => {
          onChange(JSON.stringify(json))
        }}
        readonly={readOnly}
        withPadding={false}
        showBubbleMenu={!readOnly}
      />
    </Box>
  )
}
